export function useUrlSelectedId(key: string) {
  const route = useRoute();
  const router = useRouter();

  function read(): string | undefined {
    const raw = route.query[key];
    const v = Array.isArray(raw) ? raw[0] : raw;
    return v ? String(v) : undefined;
  }

  const id = ref<string | undefined>(read());

  watch(id, (value) => {
    const query = { ...route.query };
    if (value !== undefined) query[key] = value;
    else delete query[key];
    router.replace({ query });
  });

  watch(
    () => route.query[key],
    () => {
      const fresh = read();
      if (fresh !== id.value) id.value = fresh;
    }
  );

  return id;
}
